'use client';

/** Back / Continue footer shared by the upload steps (identity, audio, documents). */
export function StepNav({
  onBack,
  onContinue,
  continueDisabled,
  disabledHint,
}: {
  onBack: (() => void) | null;
  onContinue: () => void;
  continueDisabled: boolean;
  /** Shown under the buttons while Continue is disabled. */
  disabledHint: string;
}) {
  return (
    <div className="pt-1">
      <div className="flex gap-3">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="px-5 py-3.5 rounded-xl bg-gray-800 hover:bg-gray-700 border border-gray-700 text-white text-sm font-medium transition-colors"
          >
            Back
          </button>
        )}
        <button
          type="button"
          onClick={onContinue}
          disabled={continueDisabled}
          className="btn btn-primary flex-1 py-3.5 font-semibold text-sm disabled:opacity-50 disabled:cursor-not-allowed h-auto"
        >
          Continue
        </button>
      </div>
      {continueDisabled && (
        <p className="mt-2 text-center text-xs text-gray-500">{disabledHint}</p>
      )}
    </div>
  );
}
